module.exports = __webpack_public_path__ + "img/7-1_07.c6116c29.jpg";